<template>
  <section class="no-permission">
    <div></div>
    <h3>当前用户无该操作权限，请联系管理员！</h3>
    <a-button type="primary" @click="$router.push('/login')">
      <a-icon type="left" /> 重新登录
    </a-button>
  </section>
</template>

<script>
export default {
  
}
</script>

<style lang="scss" scoped>
.no-permission {
  text-align: center;
  background: radial-gradient(#fff, #dfdfdf);
  height: 100vh;

  div {
    background: url('../../assets/images/403.png') no-repeat bottom;
    height: 45%;
  }
  h3 {
    margin-bottom: 20px;
  }

}
</style>